import React from 'react';

type Props = {
    text: string;
    maxLength: number;
    className?: string;
    textColor?: string;
    hoverTextClassname?: string;
};

const TruncatedCopyText: React.FC<Props> = ({ text, maxLength, className, textColor,hoverTextClassname }) => {
    const isTruncated = text?.length > maxLength;
    const displayText = isTruncated ? `${text?.slice(0, maxLength)}...` : text;

    return (
        <div className={`position-relative d-inline-block ${className ?? ''}`}>
            <span className={`cursor-pointer user-select-none ${textColor ?? 'text-muted'} ${className}`}>{displayText}</span>

            {isTruncated && (
                <div className={`copy-popup bg-light border rounded shadow-sm ${hoverTextClassname}`}>
                    <span className="user-select user-select-all d-block text-primary font-size-12">{text}</span>
                </div>
            )}
        </div>
    );
};

export default TruncatedCopyText;
